<template>
  <div class="common-footer">
    <div class="copy-right">
      <div>技术支持：河南省继续教育学会</div>
      <div>河南省郑州市新郑龙湖镇双湖大道8号 邮政编码：451191</div>
      <!-- <div>办公室电话：0371—58690800</div> -->
      <div>
        <a
          href="http://www.beian.miit.gov.cn/"
        >Copyright © 2018 河南医学高等专科学校 ALL RIGHT RESERVED</a>
       <a href="http://www.beian.miit.gov.cn/"> 丨豫ICP备19020798号-2</a>
      </div>
    </div>
    <span class="btn-top" @click="toPersonal"></span>
  </div>
</template>

<script>
export default {
  name: "common-footer",
  data() {
    return {
      msg: "footer"
    };
  },
  methods:{
    toPersonal:function(){
      if(localStorage.getItem("uid")){
        this.$router.push({ path: '/my' })
      }else{
        this.$router.push({ path: '/' })
      }

    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.common-footer {
  width: 100%;
  height: 140px;
  background-color: #e3e3e3;
  text-align: center;
  .copy-right {
    width: 1200px;
    margin: 0 auto;
    color: #898989;
    font-size: 14px;
    line-height: 35px;
    padding-top: 20px;
    a{color: #898989;}
  }
//   .btn-top {
//     width: 145px;
//     height: 65px;
//     position: fixed;
//     right: 0;
//     top: 80%;
//     background-image: url(../assets/center.png);
//     cursor: pointer;
//     z-index: 12;
// }
}
</style>



// WEBPACK FOOTER //
// src/commons/footer.vue